const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const NUMBERS = '0123456789';
// Keep in sync with frontend checklist: /[!@#$%^&*]/
const SPECIAL = '!@#$%^&*';
const ALL = UPPER + LOWER + NUMBERS + SPECIAL;

function randomInt(max) {
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        const values = new Uint32Array(1);
        crypto.getRandomValues(values);
        return values[0] % max;
    }

    return Math.floor(Math.random() * max);
}

function pickRandomChar(chars) {
    return chars.charAt(randomInt(chars.length));
}

function shuffle(chars) {
    const items = [...chars];
    for (let i = items.length - 1; i > 0; i--) {
        const j = randomInt(i + 1);
        [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
}

export function generateCompliantPassword(length = 12) {
    const size = Math.max(length, 8);
    const required = [
        pickRandomChar(UPPER),
        pickRandomChar(LOWER),
        pickRandomChar(NUMBERS),
        pickRandomChar(SPECIAL),
    ];

    while (required.length < size) {
        required.push(pickRandomChar(ALL));
    }

    return shuffle(required).join('');
}

function resolvePasswordInput(passwordId) {
    if (passwordId) {
        return document.getElementById(passwordId);
    }

    return document.getElementById('password-invite')
        || document.getElementById('password')
        || document.getElementById('password-update')
        || document.getElementById('new_password')
        || document.getElementById('password-practitioner-setup');
}

function resolveConfirmInput(confirmId, passwordInput) {
    if (confirmId) {
        return document.getElementById(confirmId);
    }

    if (passwordInput?.id === 'new_password') {
        return document.getElementById('confirm_password');
    }

    if (passwordInput?.id === 'password-update') {
        return document.getElementById('password_confirmation_update');
    }

    if (passwordInput?.id === 'password-practitioner-setup') {
        return document.getElementById('password_confirmation_practitioner');
    }

    return document.getElementById('password_confirmation');
}

function setPasswordVisibilityIcon(input, visible) {
    if (!input) {
        return;
    }

    const fieldRoot = input.closest('.input, .form-input, .login-field') || input.parentElement;
    const toggle = fieldRoot?.querySelector('.toggle-password')
        || document.querySelector(`[toggle="#${input.id}"]`);

    if (toggle) {
        toggle.textContent = visible ? 'visibility_off' : 'visibility';
    }
}

export function applyGeneratedPassword(options = {}) {
    const passwordInput = resolvePasswordInput(options.passwordId);
    if (!passwordInput) {
        return null;
    }

    const password = generateCompliantPassword(options.length || 12);
    const confirmInput = resolveConfirmInput(options.confirmId, passwordInput);

    passwordInput.value = password;
    passwordInput.setAttribute('type', 'text');
    setPasswordVisibilityIcon(passwordInput, true);

    if (confirmInput) {
        confirmInput.value = password;
        confirmInput.setAttribute('type', 'text');
        setPasswordVisibilityIcon(confirmInput, true);
    }

    const fieldRoot = passwordInput.closest('.input, .form-input, .login-field') || passwordInput.parentElement;
    const copyBtn = fieldRoot?.querySelector('.btn2Copy') || document.querySelector('.btn2Copy');
    if (copyBtn) {
        copyBtn.classList.remove('d-none');
    }

    ['input', 'keyup', 'change'].forEach((eventName) => {
        passwordInput.dispatchEvent(new Event(eventName, { bubbles: true }));
        if (confirmInput) {
            confirmInput.dispatchEvent(new Event(eventName, { bubbles: true }));
        }
    });

    passwordInput.focus();
    return password;
}

export function copyGeneratedPassword(passwordId) {
    const passwordInput = resolvePasswordInput(passwordId);
    if (!passwordInput) {
        return;
    }

    passwordInput.setAttribute('type', 'text');
    setPasswordVisibilityIcon(passwordInput, true);

    passwordInput.select();
    document.execCommand('copy');
}

export function installPasswordGeneratorGlobals() {
    window.generateCompliantPassword = generateCompliantPassword;
    window.applyGeneratedPassword = applyGeneratedPassword;
    window.genPassword = function genPassword() {
        if (document.getElementById('password-invite')) {
            applyGeneratedPassword({ passwordId: 'password-invite' });
            return;
        }

        applyGeneratedPassword();
    };
    window.copyPassword = function copyPassword() {
        copyGeneratedPassword();
    };
    window.genPasswordReset = function genPasswordReset() {
        applyGeneratedPassword({
            passwordId: 'password',
            confirmId: 'password_confirmation',
        });
    };
    window.genPasswordUpdate = function genPasswordUpdate() {
        applyGeneratedPassword({
            passwordId: 'password-update',
            confirmId: 'password_confirmation_update',
        });
    };
    window.genPasswordPractitionerSetup = function genPasswordPractitionerSetup() {
        applyGeneratedPassword({
            passwordId: 'password-practitioner-setup',
            confirmId: 'password_confirmation_practitioner',
        });
    };
}
